import {
  CoveragePlanCard,
  CoveragePlanGetResponse
} from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

type TempCoveragePlanGetResponse = Omit<CoveragePlanGetResponse, 'plans'> & {
  plans: Array<CoveragePlanCard>
}

export const usePlansQuery = () => {
  const fetchPlans = async () => {
    return (await medicareApiClient.asyncGetPlans()) as TempCoveragePlanGetResponse
  }

  return useQuery<TempCoveragePlanGetResponse | undefined>('plans', fetchPlans)
}
